import classNames from 'classnames';
import type React from 'react';
import { useRef } from 'react';
import type { TooltipProps } from '../Tooltip';
import { Tooltip } from '../Tooltip';

export interface DropdownMenuProps
  extends Pick<TooltipProps, 'visible' | 'offset'> {
  button?: React.ReactNode;
  placement?: TooltipProps['placement'];
  children: React.ReactNode;
  toggleDropdown?: () => void;
  onClose?: () => void;
  scroll?: boolean;
  disabled?: boolean;
  noPadding?: boolean;
  largeShadow?: boolean;
  scrollAuto?: boolean;
}

/** @deprecated
 * This component is deprecated, please use Dropdown component instead.
 * */

export const DropdownMenu = ({
  children,
  button,
  visible,
  toggleDropdown,
  onClose,
  offset,
  scroll,
  placement = 'bottom-start',
  disabled,
  noPadding,
  largeShadow = false,
  scrollAuto = false,
}: DropdownMenuProps) => {
  const dropdownMenuRef = useRef<HTMLDivElement>(null);

  return (
    <div onMouseLeave={onClose}>
      <div
        onClick={() => {
          toggleDropdown?.();
        }}
        ref={dropdownMenuRef}
      >
        {button}
      </div>
      {!disabled && (
        <Tooltip
          offset={offset}
          shadow={largeShadow ? 'xl' : undefined}
          placement={placement}
          interactive
          trigger="click"
          visible={visible}
          hideOnClick
          noArrow
          anchorRef={dropdownMenuRef}
        >
          <div
            className={classNames(noPadding ? 'p-0' : 'p-1.5', {
              'overflow-y-auto': scroll || scrollAuto,
              'max-h-80': scroll,
              'max-h-64': scrollAuto,
            })}
          >
            {children}
          </div>
        </Tooltip>
      )}
    </div>
  );
};
